<template>
  <div>
    <ejs-grid
      ref="gridForQueryData"
      :dataSource="dataForList"
      :columns="tableColumns"
      :allowResizing="true"
    ></ejs-grid>
    <ejs-pager
      ref="pager"
      @click="pageLoadTableData()"
      :currentPage="page.currentPage"
      :pageCount="page.pageCount"
      :pageSize="page.pageSize"
      :totalRecordsCount="page.totalRecordsCount"
    ></ejs-pager>
  </div>
</template>
<script>

import commonUtil from './commonUtil';

import {
  Reorder,
  Resize,
  ExcelExport,
  ContextMenu
} from '@syncfusion/ej2-vue-grids';

export default {
  name: 'GridForQueryData',
  data() {
    return {
      page: {
        currentPage: 1,
        pageSize: 25,
        totalRecordsCount: 0,
        pageCount: 10
      },
      dataForList: [{}],
      tableColumns: [],
      msg: undefined
    };
  },
  mounted() { },
  provide: {
    grid: [Reorder, Resize, ExcelExport, ContextMenu]
  },
  methods: {
    pageLoadTableData() {
      this.loadTableData(this.msg);
    },
    loadTableData(msg) {
      let _this = this;
      let url = '/lte/pm/currenttime/collect/dataList';
      let params = {};
      let pageParams = {};
      _this.page.currentPage = _this.$refs.pager.ej2Instances.currentPage;
      pageParams.pageNo = _this.page.currentPage;
      pageParams.pageSize = _this.page.pageSize;

      params.page = pageParams;
      params.systemId = 1;
      params.taskId = msg.taskId;

      this.msg = msg;

      this.$axios.post(url, params).then(response => {
        let indicators = {};
        // 解析指标的字段翻译
        for (let index = 0; index < _this.msg.taskIndicators.length; index++) {
          indicators[
            _this.msg.taskIndicators[index].counterCode
          ] = _this.msg.taskIndicators[index].counterName;
        }
        // 抽出第一条数据，用来构建表头
        let data = response.data.resultVal.result[0];
        // 如果表头为空的情况下进行处理
        if (_this.tableColumns.length === 0) {
          for (let item in data) {
            switch (item) {
              case 'sys_meter_timely_task_id':
                _this.tableColumns.push({
                  field: 'sys_meter_timely_task_id',
                  headerText: this.$t('Pm.taskID'),
                  textAlign: 'center',
                  clipMode: 'EllipsisWithTooltip'
                });
                break;

              case 'ne_id':
                _this.tableColumns.push({
                  field: 'ne_id',
                  headerText: this.$t('Pm.ne_id'),
                  textAlign: 'center',
                  clipMode: 'EllipsisWithTooltip'
                });
                break;

              case 'ne_name':
                _this.tableColumns.push({
                  field: 'ne_name',
                  headerText: this.$t('Pm.resource_name'),
                  textAlign: 'center',
                  clipMode: 'EllipsisWithTooltip'
                });
                break;

              case 'statistic_cycle':
                _this.tableColumns.push({
                  field: 'statistic_cycle',
                  headerText: this.$t('Pm.samplingPeriod_unit'),
                  textAlign: 'center',
                  clipMode: 'EllipsisWithTooltip'
                });
                break;

              case 'Intodb_time':
                _this.tableColumns.push({
                  field: 'Intodb_time',
                  headerText: this.$t('Pm.reportTime'),
                  textAlign: 'center',
                  clipMode: 'EllipsisWithTooltip'
                });
                break;

              case 'assoc_id':
                _this.tableColumns.push({
                  field: 'assoc_id',
                  headerText: this.$t('Pm.assocId'),
                  textAlign: 'center',
                  clipMode: 'EllipsisWithTooltip'
                });
                break;

            case 'cell_id':
               this.tableColumns.push({
                field: 'cell_id',
                headerText: this.$t('Pm.cellId'),
                textAlign: 'center',
                clipMode: 'EllipsisWithTooltip'
              });
              break;

            case 'enodeb_id':
               this.tableColumns.push({
                field: 'enodeb_id',
                headerText: this.$t('Pm.enodebId'),
                textAlign: 'center',
                clipMode: 'EllipsisWithTooltip'
              });
              break;

              case 'proId':
                _this.tableColumns.push({
                  field: 'proId',
                  headerText: this.$t('Pm.processCode'),
                  textAlign: 'center'
                });
                break;

              case 'start_time':
                _this.tableColumns.push({
                  field: 'start_time',
                  headerText: this.$t('Pm.start_time'),
                  textAlign: 'center',
                  clipMode: 'EllipsisWithTooltip'
                });
                break;

              case 'end_time':
                _this.tableColumns.push({
                  field: 'end_time',
                  headerText: this.$t('Pm.end_time'),
                  textAlign: 'center',
                  clipMode: 'EllipsisWithTooltip'
                });
                break;

              case 'ne_type_code':
                _this.tableColumns.push({
                  field: 'ne_type_code',
                  headerText: this.$t('Pm.resource_name'),
                  textAlign: 'center',
                  clipMode: 'EllipsisWithTooltip'
                });
                break;

              default:
                _this.tableColumns.push({
                  field: item,
                  headerText: indicators[item],
                  textAlign: 'center',
                  clipMode: 'EllipsisWithTooltip'
                });
                break;
            }
          }
        }

        _this.dataForList = response.data.resultVal.result;
        _this.page.currentPage = response.data.resultVal.pageNo;
        _this.page.totalRecordsCount = response.data.resultVal.totalCount;
      });
    }
  }
};
</script>
